module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sergey_619227.png";